import { render, staticRenderFns } from "./QuoteBoard.vue?vue&type=template&id=993ca65e&"
import script from "./QuoteBoard.vue?vue&type=script&lang=js&"
export * from "./QuoteBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports